module.exports = __webpack_public_path__ + "img/5m1.95086a18.jpg";